export default __webpack_public_path__ + "static/media/3669_124705.9c445e51.svg";